import { render } from "./InquiryManageListForm.vue?vue&type=template&id=e0a7028e&lang=true"
import script from "./InquiryManageListForm.vue?vue&type=script&lang=js"
export * from "./InquiryManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__